import type { ReactNode } from 'react';
import classnames from 'classnames';
import { ChapterTitle } from '../../atoms/chapterTitle/ChapterTitle';
import { Icon, IconColor } from '../../atoms/icon/Icon';
import { ParagraphTitle } from '../../atoms/paragraphTitle/ParagraphTitle';

interface ICardHeaderProps {
    children: ReactNode;
    className?: string;
    icon?: string;
    isLarge?: boolean;
}

export function CardHeader(props: ICardHeaderProps) {
    if (props.isLarge) {
        return (
            <div className={classnames('card__header card__header--large', props.className || '')}>
                <ChapterTitle>{props.children}</ChapterTitle>
                {props.icon && (
                    <div className="float-right ml-2">
                        <Icon
                            color={IconColor.primary}
                            icon={props.icon}
                            size="xlarge"
                        />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="card__header">
            <ParagraphTitle>{props.children}</ParagraphTitle>
            {props.icon && (
                <div className="card-icon ml-2">
                    <Icon
                        color={IconColor.primary}
                        icon={props.icon}
                        size="small"
                    />
                </div>
            )}
        </div>
    );
}
